export enum VisitStatus {
  CHECKIN_IN_PROGRESS = 'CHECKIN_IN_PROGRESS',
  CHECKIN_REJECTED = 'CHECKIN_REJECTED',
  IN = 'IN',
  OUT = 'OUT',
  PRECHECKED_IN = 'PRECHECKED_IN',
  DRY_PRECHECKED_IN = 'DRY_PRECHECKED_IN',
}
